<template>
  <b-modal
    id="modal-edit-user"
    title="Editar Usuário"
    size="xl"
    ok-title="Salvar"
    cancel-title="Cancelar"
    @hidden="leave"
    @ok="save"
  >
    <div
      v-if="loading"
      class="text-center"
    >
      <b-spinner
        variant="primary"
        type="grow"
        label="Spinning"
      ></b-spinner>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-6">
          <label for="input-name">Nome:</label>
          <b-form-input
            id="input-name"
            v-model="myUser.name"
          />
        </div>
        <div class="col-6">
          <label for="input-email">E-mail:</label>
          <b-form-input
            id="input-email"
            v-model="myUser.email"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <label for="input-celphone">Telefone:</label>
          <b-form-input
            id="input-celphone"
            v-model="myUser.celphone"
          />
        </div>
        <div class="col-6">
          <label for="input-cpf">CPF:</label>
          <b-form-input
            id="input-cpf"
            v-model="myUser.cpf"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <label for="input-birthday">Data de Nascimento:</label>
          <b-form-input
            type="date"
            id="input-birthday"
            v-model="myUser.birthday"
          />
        </div>
        <div class="col-6">
          <label for="input-occupation">Cargo:</label>
          <b-form-input
            id="input-occupation"
            v-model="myUser.occupation"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <label for="departament">Departamento:</label>
          <select
            id="departament"
            class="form-control"
            v-model="myUser.department"
          >
            <option value="Vendas">Vendas</option>
            <option value="Pós-Vendas">Pós-Vendas</option>
            <option value="Administrativo">Administrativo</option>
            <option value="Financeiro">Financeiro</option>
            <option value="RH">RH</option>
            <option value="Qualidade">Qualidade</option>
            <option value="Marketing">Marketing</option>
          </select>
        </div>
        <div class="col-6">
          <label for="input-city">Cidade:</label>
          <b-form-input
            id="input-city"
            v-model="myUser.city"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <label for="input-cnpj">CNPJ:</label>
          <b-form-input
            id="input-cnpj"
            v-model="myUser.cnpj"
          />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import EventBus from '../../../eventBus';

export default {
  props: ['user'],

  data: () => ({
    myUser: {},
    loading: true,
  }),

  mounted() {
    this.loading = true;

    this.myUser = {
      name: this.user.name,
      email: this.user.email,
      celphone: this.user.celphone,
      cpf: this.user.cpf,
      birthday: this.user.birthday,
      occupation: this.user.occupation,
      city: this.user.city,
      cnpj: this.user.cnpj,
      department: this.user.department,
    };

    this.loading = false;
  },

  methods: {
    leave() {
      this.myUser = {
        name: this.user.name,
        email: this.user.email,
        celphone: this.user.celphone,
        cpf: this.user.cpf,
        birthday: this.user.birthday,
        occupation: this.user.occupation,
        city: this.user.city,
        cnpj: this.user.cnpj,
        department: this.user.department,
      };
    },

    save() {
      EventBus.$emit('saveUserInfo', this.myUser);
    },
  },
};
</script>

<style scoped>
</style>
